import { requestGet, requestPost, requestGetFilterEmpty } from '@/common/request';

export default {
  // 活动商品池详情
  async getGoodsPoolInfo(data) {
    return await requestGet('/goodsPool/info', data);
  },
  // 会场运营 逆向流程 关联活动弹窗列表
  async activityPlanListRelated(data) {
    return await requestGet('/activityPlan/listRelated', data);
  },
  // 活动模块-关联活动
  async activityPlanRelate(query) {
    return await requestGet('/activityPlan/relate', query);
  },
  // 活动模块-取消关联
  async activityPlanRelieve(query) {
    return await requestGet('/activityPlan/relieve', query);
  },

  async goodsPoolMyCreated(data) {
    return await requestGet('/goodsPool/myCreated', data);
  },
  // 创建活动商品池
  async goodsPoolCreatePool(data) {
    return await requestGet('/goodsPool/createPool', data);
  },
  // 会场运营 逆向流程 卡片列表
  async actRoomListReverse(data) {
    return await requestGet('/actRoom/listReverse', data);
  },
  // 会场模块-关联会场
  async actRoomCorrelate(query) {
    return await requestPost('/actRoom/correlate', undefined, { body: query });
  },
  // 会场模块-取关会场
  async actRoomRelieve(query) {
    return await requestGet('/actRoom/relieve', query);
  },
  // 我的创建 综促列表
  async zongcuMylist(query) {
    return await requestGetFilterEmpty('/zongcu/myList', query);
  },
  // 创建综促活动的类型 权限按钮
  async zongcuCanBeCreated(query) {
    return await requestGet('/zongcu/canBeCreated', query);
  },
  async roomGetActType(query) {
    return await requestGet('/room/getActType', query);
  },
  // 我的创建 综促列表
  async zongcuMyManagerList(query) {
    return await requestGet('/zongcu/myManagerList', query);
  },
};
